import React from "react";
import MyDocuments from "../MyDocuments";
import MyDocumentsNewProject from "../MyDocumentsNewProject"
import AdminNavBar from "../AdminSideNavBar";
import SideNavBar from "../SideNavBar";
import { withRouter } from "react-router-dom";
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import authService from "../../services/authService";
import MyDocumentsNew from "../MyDocumentsNew";
import CoAuthorNewProject from "../Forms/CoAuthorNewProject";

const MyDocumentsNewProjectPage = props => {
  const user = authService.getCurrentUser();
  let userData = {};
  const coAuthor = props.location.state;

  if (props.location.state) {
    userData = props.location.state.userData;
    console.log("myNewDocumentPage", userData);
  }
  if (!user.isAdmin) {
    return (
      <SideNavBar>
        {/* <MyDocuments /> */}
        <CoAuthorNewProject isCoAuthor={false}/>
      </SideNavBar>
    );
  } else {
    return (
      <AdminNavBar>
        <MyDocuments data={userData} />
      </AdminNavBar>
    );
  }
};

export default NetworkDetector(withRouter(MyDocumentsNewProjectPage));
